export const Config = {
    // セッションストレージのキー
    SESSION_STORAGE: {
        DATA: {
            intro: true,
        },
        KEY: 'atrianime',
    },
};
